export enum GzDialogEvents {
  CONFIRM = 'gzDialogConfirm',
  CANCEL = 'gzDialogCancel',
  OPENED = 'gzDialogOpened',
}

export interface GzDialog {
  onCloseHandler?: null | Function;
  headline: string;
  bodyContent?: HTMLElement;
  footerContent?: HTMLElement;
  isOpen?: boolean;
  isWindow?: boolean;
  closableOutsideBox?: boolean;
  overlayZIndex?: number;
  autoCloseOnConfirm?: boolean;
}
